import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, references } from '@apexdesigner/schema-tools';

export const tenantAssignment = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    tenantId: z.uuid().hidden().describe('Foreign key to Tenant'),

    userId: z
      .uuid()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to User'),

    tenant: belongsTo('Tenant'),

    user: references('User'),
  })
  .describe(
    'Assigns a user to a tenant. A user can be assigned to multiple\ntenants; the tenancy library reads these assignments to determine\nwhich tenants a user can access.',
  )
  .as('TenantAssignment');

export { tenantAssignment as tenantAssignmentSchema };
